import React, { useEffect, useState } from 'react';
import './ConfirmDialog.css';

function ConfirmDialogButton({ label, onClick, disabled = false }) {
  return (
    <button
      type="button"
      className={`admin-confirm-button ${disabled ? 'admin-confirm-button--disabled' : ''}`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      <span className="admin-confirm-button__svg" aria-hidden="true">
        <svg
          className="admin-confirm-button__polygon"
          viewBox="0 0 200 46"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.64062 9.71568L13.0408 1.55315L187.205 1.55317L198.605 9.7157V36.2768L187.205 44.4393L13.0408 44.4393L1.64062 36.2768V9.71568Z"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      </span>
      <span className="admin-confirm-button__text">{label}</span>
    </button>
  );
}

function ConfirmDialog({
  isOpen,
  title = 'CONFIRM ACTION',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  busy = false,
  hideCancel = false,
  cancelFirst = false,
  consentLabel = null,
  requireConsent = false,
}) {
  const [consentChecked, setConsentChecked] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setConsentChecked(false);
      return;
    }
    setConsentChecked(false);
  }, [consentLabel, isOpen, message, requireConsent, title]);

  if (!isOpen) return null;

  const confirmDisabled = busy || (requireConsent && !consentChecked);
  const cancelButton = !hideCancel ? (
    <ConfirmDialogButton label={cancelText} onClick={onCancel} disabled={busy} />
  ) : null;
  const confirmButton = (
    <ConfirmDialogButton
      label={busy ? 'Sending...' : confirmText}
      onClick={onConfirm}
      disabled={confirmDisabled}
    />
  );

  return (
    <div className="admin-confirm-dialog-overlay" role="dialog" aria-modal="true" aria-label={title}>
      <div className="admin-confirm-dialog-card">
        <p className="admin-confirm-dialog-title">{title}</p>
        <p className="admin-confirm-dialog-message">{message}</p>
        {consentLabel ? (
          <div className="admin-confirm-dialog-consent">
            <label className="admin-confirm-dialog-consent-label">
              <input
                type="checkbox"
                checked={consentChecked}
                onChange={(event) => setConsentChecked(event.target.checked)}
              />
              <span className="admin-confirm-dialog-consent-copy">{consentLabel}</span>
            </label>
          </div>
        ) : null}

        <div className={`admin-confirm-dialog-actions ${hideCancel ? 'single' : ''}`}>
          {cancelFirst ? cancelButton : confirmButton}
          {cancelFirst ? confirmButton : cancelButton}
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
